// @flow
import * as React from "react";
import {findDOMNode} from "react-dom";
import PropTypes from 'prop-types';
import {reisy, use} from "reisy";
import {observable, action} from "mobx";
import {observer} from "mobx-react";
import moment from "moment";

import {injectIntl, defineMessages} from "react-intl";
import Page from "../components/page.js";
import * as PrevNext from "../components/prevnext.js";
import Related from "../components/related.js";
import mapKey, {LEFT, RIGHT, UP, DOWN} from "../components/mapkey.js";
import Scroller from "../scroller/index.js";
import {Position} from "../scroller/utils.js";
import Navigation from "../navigation/index.js";
import ModeSwitcher from "../components/modeswitcher.js";
import PageIndicator from "../components/pageindicator.js";
import Footer from "../components/footer.js";
import {isIOS, isHeadless} from '../environment.js';
import {getBestMode} from "../components/modeswitcher.js";
import Heading from '../components/heading';
import {isMobile, isIE, isEdge, isFirefox, hasPositionStickySupport} from "../environment.js";
import {UpArrow} from '../components/icons';

const messages = defineMessages({
	submitted: {
		id: "forms.submitted",
		defaultMessage: "Your form data was successfully submitted.",
	},
	errored: {
		id: "forms.errored",
		defaultMessage: "There was a problem submitting your form data.",
	},
	close: {
		id: "forms.close",
		defaultMessage: "Thank you",
	},
	dateLabel: {
		id: "meta.dateLabel",
		defaultMessage: "published on ",
	}
});

export const styles = reisy`
@namespace Reader;

JackInTheBox: $Settings.JackInTheBox;
JackInTheBoxContainReader: $Settings.JackInTheBoxContainReader;
VerticalPrevNextMode: inline;
showRelated: false;
relatedCount: 3;
showFooter: false;
stretchPages: true;
navbarExpanded: back - locale user share collapse;
navbarCollapsed: back - share;
navbarBehavior: transparent;
showBackToTop: false;
restoreScrollToTop: false;
showMetaFooter: false;

Container {
	@extends Helpers.Fullscreen;
	color: black;
	min-height: 1024px;

	@media (max-height: 1024px) {
		min-height: 100vh;
	}
}

Flow {

}

Desktop {

}

Contain {
	@extends Helpers.Contain;
}
Fixed {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
}

FixedVertical {
	position: fixed;
	left: 0;
	right: 0;
	z-index: 0;
}
Sticky {
	position: sticky;
}
FixedTop {
	@extends FixedVertical;
	top: 0;
}
FixedBottom {
	@extends FixedVertical;
	bottom: 0;
}

FixedHorizontal {
	@extends Helpers.ScrollbarBottom;
	position: fixed;
	top: 0;
	z-index: 0;
}
FixedLeft {
	@extends FixedHorizontal;
	left: 0;
}
FixedRight {
	@extends FixedHorizontal;
	right: 0;
}

Shadow {
	box-shadow: 0 0 3.75em 1.25em rgba(0, 0, 0, 0.5);
}

FormWrapper {
	@extends Helpers.AbsFull;
	position: fixed;
	height: 100vh;
	margin-bottom: -100vh;
	bottom: auto;

	z-index: 5;
	opacity: 0;
	visibility: hidden;
	transition: opacity $Consts.Transition, visibility 0ms $Consts.Transition;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.4);
}
FormSticky {
	position: sticky;
}
formSubmitted {
	opacity: 1;
	visibility: visible;
	transition: opacity $Consts.Transition;
}
Form {
	background: white;
	padding: 2em;
	box-shadow: 2px 2px 8px 2px rgba(0, 0, 0, 0.3);
	border-radius: 3px;
}
FormTitle {
	margin-top: 0;
}
FormButton {
	display: block;
	margin: auto;
}
isMobile {

}
isDesktop {

}
isIE {
	
}
noPositionStickySupport {

}
BackToTop {
	position: fixed;
	bottom: 1rem;
	right: 1rem;
	z-index: 9999;
	background: rgba(0,0,0,0.8);
	border-radius: 100%;
	width: 3rem;
	height: 3rem;
	display: flex;
	justify-content: center;
	align-items: center;
	opacity: .2;
	transition: all .3s ease-out;

	&:hover {
		opacity: 1;
	}

	svg {
		margin-top: .25rem;
		fill: #fff;
		stroke: #fff;
		stroke-width: 1px;
		width: 2rem;
		height: 2rem;
		opacity: .8;
	}
}
MetaFooter {
	text-align: center;
	padding: 2rem 1rem;
	font-family: $Fonts.aside;
}
`;

export const Shadow = ({zIndex}: {zIndex: number}) => (
	<div {...use(styles.Shadow, {zIndex})} />
);

class BackToTop extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			show: false,
		}
	}
	handleScroll = () => {
		this.setState({ show: window.pageYOffset > 200 });
	}
	componentDidMount() {
		if (!IS_BROWSER) { return; }
		window.addEventListener("scroll", this.handleScroll);
		this.handleScroll();
	}
	componentWillUnmount() {
		window.removeEventListener("scroll", this.handleScroll);
	}
	render() {
		return <aside {...use(styles.BackToTop, this.state.show ? null : { opacity: 0, visibility: 'hidden' })} onClick={this.props.onClick}><UpArrow /></aside>
	}
}

const MetaFooter = ({story, formatMessage}) => {
	return <div {...use(styles.MetaFooter)}>
		{`${formatMessage(messages.dateLabel)}${moment(story.publishDate).format('DD.MM.YYYY')}`}
	</div>
}

type Props = {
	page: string;
	// TODO:
	story: any;
	prev: any;
	next: any;
	fonts: any;
	intl: any;
};

type Mode = "flow" | "horizontal" | "vertical";

class Reader extends React.Component {
	static contextTypes = {
		player: PropTypes.object,
	};

	props: Props;

	position: Position = new Position();
	@observable zoom: number = 1;
	@observable mode: Mode;
	formSubmitCb: () => void;
	@observable formSubmit: Error | boolean = false;

	scroller: Scroller;
	setScroller = (scroller: Scroller) => (this.scroller = scroller);
	_scrollPositions = {};

	constructor(props: Props) {
		super(props);
		this.handleKeydown = this.handleKeydown.bind(this);
		this.handlePosition = this.handlePosition.bind(this);
		this.jackInTheBox = styles.JackInTheBox;
		this.containReader = styles.JackInTheBoxContainReader;
		this.componentWillReceiveProps(props);
	}

	componentDidMount() {
		if (!IS_BROWSER) { return; }
		document.addEventListener("keydown", this.handleKeydown);
		window.addEventListener('resize', this.handleResizeDelayed);
		if(this.jackInTheBox && !this.containReader) {
			document.body.style.overflow = "hidden";
		}
	}

	componentWillUnmount() {
		document.removeEventListener("keydown", this.handleKeydown);
		window.removeEventListener('resize', this.handleResizeDelayed);
		this.props.fonts.release();
		if(this.jackInTheBox && !this.containReader) {
			document.body.style.overflow = "";
		}
	}

	componentWillReceiveProps(props: Props) {
		// release/inject fonts if they changed
		const {fonts, story} = this.props;
		if (fonts && fonts !== props.fonts) {
			this.props.fonts.release();
		}
		props.fonts.inject();

		if (story !== props.story) {
			//save current position for later
			if (this.scroller) {
				this._scrollPositions[story.id] = styles.restoreScrollToTop ? 1 : this.scroller.currentScroll;
			}
			this.position = new Position();
		}

		// change mode depending on params
		const mode = props.page === "flow" ? "flow" : props.story.scrollDirection;
		const page = parseInt(props.page, 10) || 1;
		if (mode !== this.mode || this.position.page !== page) {
			this.setModeAndPage(props, mode, page);
		} 
		const anchor = props.anchor || props.story.options.noSnapping === true && page > 1 && `page-${page}`;
		if (anchor && this.position.anchor !== anchor && (this._scrollPositions[props.story.id] || 0) <= 1) {
			this.handleAnchor(anchor);
		} else {
			this.position.anchor = false;
		}

		if (this.zoom !== props.zoom) {
			this.setZoom(props.zoom);
		}
	}

	@action setZoom(zoom: Number) {
		this.zoom = zoom;
	}

	@action setModeAndPage(props: Props, mode: Mode, page: number) {
		this.mode = mode;

		let scroll = props.story.options.noSnapping ? 0 : page - 1;
		let max = (mode === "flow" ? 1 : props.story.pages.length) - 1;
		if (this.hasDrawer()) {
			if (props.prev) {
				scroll += 1;
				max += 1;
			}
			if (props.next) { max += 1; }
		}

		const {position} = this;
		position.page = page;
		position.target = scroll;
		position.scroll = scroll;
		position.max = max;
	}

	@action setPosition(page, scroll) {
		const {position} = this;
		position.page = page;
		position.scroll = scroll;
	}

	handleResize = () => {
		if (IS_BROWSER) {
			const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
			if(fullscreenElement) { return }
		}
		let bestMode = getBestMode();
		bestMode = bestMode === 'mobile' ? 'flow' : this.props.story.scrollDirection;
		if (this.mode !== bestMode) {
			let page = 1;
			if (bestMode === 'flow') {
				page = 'flow';
			} 
			this.context.player.navigateTo({query: {page}}, true);
		}
	}

	resizeTimeout = null;
	handleResizeDelayed = () => {
		clearTimeout(this.resizeTimeout);
		this.resizeTimeout = setTimeout(this.handleResize, 100);
	}


	anchorTimeout = null;
	handleAnchor(anchor) {
		this.position.anchor = anchor;
		if (!anchor || anchor.match(/(:~:)?targetText/)) { return; }
		clearTimeout(this.anchorTimeout);
		this.anchorTimeout = setTimeout(() => {
			if (this.scroller) {
				const page = this.mode === "flow" ? this.props.story.flow : this.props.story.pages[0];
				this.anchorTimeout = null;
				page.load().then(() => {
					if(!this.anchorTimeout) {
						this.anchorTimeout = setTimeout(() => {
							const elem = findDOMNode(this.scroller).querySelector(`#${anchor}, a[name=${anchor}]`);
							elem && this.scroller.scrollToElem(elem, 0);
						}, 150);
					}
				})
			}
		}, 100);
	}

	handlePosition = (_position: number) => {
		const {prev, story} = this.props;
		const position = Math.max(1, Math.min(_position + (prev && this.hasDrawer() ? 0 : 1), story.pages.length));
		this.setPosition(position, _position);

		const {player} = this.context;
		const page = String(position);
		if (this.mode === "flow" || page === this.props.page) { return; }
		const {tags} = player.url.query;
		player.navigateTo({query: {page, tags}}, !player.options.historyPerPage);
	}

	makePositionLink = (_position: number): any => {
		const {prev, story} = this.props;
		const position = _position + (prev && this.hasDrawer() ? 0 : 1);
		if (position < 1 || position > story.pages.length) { return null; }
		return {query: {page: position}};
	}

	handleKeydown = (ev: KeyboardEvent) => {
		if (ev.altKey || ev.ctrlKey || ev.metaKey || ev.shiftKey) { return; }
		const {prev, next} = this.props;
		const {player} = this.context;
		const horizontal = this.mode === "horizontal";
		const key = mapKey(ev);

		if (!horizontal && this.containsScroll() && !this.hasDrawer()) { return; }

		if (
			document.activeElement &&
			document.activeElement.tagName &&
			document.activeElement.tagName.toLowerCase() === "input"
		) {
			return;
		}

		const isScrollToStart = horizontal ? LEFT.includes(key) : UP.includes(key);
		const isScrollToEnd = horizontal ? RIGHT.includes(key) : DOWN.includes(key);

		if (isScrollToStart) {
			if (prev) {
				player.navigateTo(prev.href);
			} else {
				this.scroller.bounce("start");
			}
			ev.preventDefault();
		} else if (isScrollToEnd) {
			if (next) {
				player.navigateTo(next.href);
			} else {
				this.scroller.bounce("end");
			}
			ev.preventDefault();
		}
	}

	formatMessage = msg => this.props.intl.formatMessage(msg);

	handleFormSubmit = action((err, cb) => {
		this.formSubmitCb = cb;
		this.formSubmit = err || true;
	})

	handleFormSubmitClose = action(() => {
		this.formSubmit = false;
		this.formSubmitCb();
	})

	handleBeforeFocus = () => {
		//restore previously stored scroll position
		this.beforeFocusScroll = this._scrollPositions[this.props.story.id] || this.scroller.currentScroll;
		delete this._scrollPositions[this.props.story.id];
		this.scroller.currentScroll = this.beforeFocusScroll;
	}

	handleFocus = () => {
	 	if (this.scroller) {
		 	this.scroller.currentScroll = this.beforeFocusScroll;
			this.scroller.handleResize(true);
			this.handleAnchor(this.position.anchor);
	 	}
	}

	handlePageSizeChange = () => {
		this.scroller.handleResize();
	}

	shouldComponentUpdate(props: Props) {
		return props.story !== this.props.story ||
			(props.page !== this.props.page &&
				(props.page === "flow" || this.props.page === "flow"));
	}

	hasDrawer() {
		return (!this.jackInTheBox || !this.containReader) && (this.mode === 'horizontal' || styles.VerticalPrevNextMode === 'drawer');
	}

	containsScroll() {
		const {jackInTheBox, containReader} = this;
		return isIOS && this.context.player.options.isEmbedded || jackInTheBox && !containReader;
	}

	scrollToStart = () => {
		const elem = this.scroller.elem.querySelector('#page-1 .kent-page');
		if(elem) { 
			this.scroller.scrollToElem(elem, 0);
			this.scroller.setTargetPosition(0); 
		}
	}

	render() {
		const {position, mode, formSubmit, jackInTheBox, containReader, zoom} = this;
		const {story, fonts, prev, next, stylePrefix} = this.props;
		const {noFlow, noRelated} = story.options || {};
		const {formatMessage} = this.props.intl;
		const horizontal = mode === "horizontal";

		const isPrinting = IS_BROWSER && window.matchMedia('print').matches || isHeadless;
		const isIndexStory = story.publisher && story.publisher.index && story.publisher.index.id === story.id;

		const stretch = styles.stretchPages !== false && (mode === "flow" || horizontal || story.pages.length === 1);
		const pages = (mode === "flow" ? [story.flow] : story.pages).map(
			(page, i) => {
				if (isPrinting) { page.load(stylePrefix) }
				return IS_BROWSER || (i + 1 === position.page)
					? <Page
						key={page.url} page={page}
						horizontal={horizontal}
						index={i + 1}
						position={position}
						zoom={zoom}
						stylePrefix={stylePrefix}
						onFormSubmit={this.handleFormSubmit}
						onBeforeFocus={this.handleBeforeFocus}
						onAfterFocus={this.handleFocus}
						onSizeChange={this.handlePageSizeChange}
						formatMessage={this.formatMessage}
						scrollToStart={this.scrollToStart}
						story={story}
						stretch={stretch} />
					: null}).filter(Boolean);

		const drawer = this.hasDrawer();
		const containScroll = this.containsScroll();

		//fetch the backgroundcolor of the last page in the story for prevnext
		const backgroundColor = (mode === "flow" ? story.flow : story.pages.slice(-1)[0]).background.color || '#ffffff';
		const firstBackgroundColor = (mode === "flow" ? story.flow : story.pages[0]).background.color || '#ffffff';

		const fontInject = fonts.toCSS();
		return (
			<section
				{...use(styles.Container, (mode === "flow" ? styles.Flow : styles.Desktop), jackInTheBox && styles.Contain, jackInTheBox && !containReader && styles.Fixed, story.options && story.options.className, isMobile ? styles.isMobile : styles.isDesktop, isIE && styles.isIE, !hasPositionStickySupport && styles.noPositionStickySupport)} 
				style={zoom > 1 ? {width: zoom * 100 + '%'} : {}} 
				data-host={this.context.player.options.absoluteHost}
				data-lookupid={story.id}
			>
				 {horizontal ? <PageIndicator
					story={story}
					startsAt={prev ? 1 : 0}
					position={position} /> : null}
				<Navigation styles={styles} translations={story.translations} contrastHint={firstBackgroundColor} />
				<div {...use(styles.FormWrapper, formSubmit && styles.formSubmitted, jackInTheBox && styles.FormSticky)}>
					{formSubmit && <section {...use(styles.Form)}>
						<Heading lvl={2} {...use(styles.FormTitle)}>
							{formatMessage(formSubmit instanceof Error ? messages.errored : messages.submitted)}
						</Heading>
						<button {...use(styles.FormButton)} onClick={this.handleFormSubmitClose}>
							{formatMessage(messages.close)}
						</button>
					</section>}
				</div>
				{fontInject && <style dangerouslySetInnerHTML={{__html: fontInject}} />}
				{prev && drawer && <div {...use(horizontal ? styles.FixedLeft : styles.FixedTop, !horizontal && jackInTheBox && styles.Sticky)}>
					<PrevNext.Drawer
						{...prev} vertical={!horizontal} direction="prev"
						position={horizontal ? "Left" : "Top"} />
				</div>}
				<Scroller
					ref={this.setScroller}
					zIndex={1}
					id="ps-player-scroller"
					isSinglePage={pages.length === 1 || story.options.noSnapping === true}
					snapToEdges={mode !== "flow" && (!this._scrollPositions[story.id] || story.options.noSnapping !== true)}
					position={position}
					onPositionChange={this.handlePosition}
					makePositionLink={this.makePositionLink}
					containScroll={containScroll}
					direction={horizontal ? "horizontal" : "vertical"}>
					{IS_BROWSER && prev && drawer && <PrevNext.Target {...prev} position={horizontal ? "Left" : "Top"} />}
					{prev && drawer && <Shadow zIndex={1} />}
					{pages.map((page, i) => zoom > 1 ? page : (
						<Scroller key={i} id={`page-${i+1}`} direction={horizontal ? "vertical" : "horizontal"} zIndex={2}>
							{page}
						</Scroller>))}
					{next && drawer && <Shadow zIndex={1} />}
					{IS_BROWSER && next && drawer && <PrevNext.Target {...next} position={horizontal ? "Right" : "Bottom"} />}
					{styles.showMetaFooter ? <MetaFooter story={story} formatMessage={this.formatMessage} /> : null}
					{styles.showRelated && !noRelated && <Related story={story} count={styles.relatedCount} />}
					{!drawer && (prev || next) ?
						<PrevNext.TagWrapper style={{backgroundColor}}>
							{!drawer && <div>
								{prev && <PrevNext.Tag {...prev} direction="prev" />}
							</div>}
							{!drawer && <div>
								{next && <PrevNext.Tag {...next} direction="next" />}
							</div>}
						</PrevNext.TagWrapper>
					: null}				
				</Scroller>
				{next && drawer && <div {...use(horizontal ? styles.FixedRight : styles.FixedBottom, !horizontal && jackInTheBox && styles.Sticky)}>
					<PrevNext.Drawer
						{...next} vertical={!horizontal} direction="next"
						position={horizontal ? "Right" : "Bottom"} />
				</div>}
				{!drawer && styles.showFooter && <Footer publisher={story.publisher} />}
				{styles.showBackToTop && !horizontal ? <BackToTop onClick={this.scrollToStart} /> : null}
			</section>
		);
	}
}

export default injectIntl(observer(Reader));



// WEBPACK FOOTER //
// ./lib/screens/reader.js